import React, { useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { useSelector, useDispatch } from "react-redux";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { fetchSliderGroup } from "../../redux/slices/sliderGroupSlice";
import API from "../../api";

const Slider = () => {
  const dispatch = useDispatch();
  const lang = useSelector((state) => state.lang.lang);
  const { dataSliderGroup } = useSelector((state) => state.sliderGroup);

  useEffect(() => {
    dispatch(fetchSliderGroup());
  }, [dispatch]);

  // dataSliderGroup null değilse 0. elemanı al
  const homepageSlider = dataSliderGroup ? dataSliderGroup[0] : null;

  return (
    <div className="home-slider">
      {homepageSlider &&
      homepageSlider.sliders &&
      homepageSlider.sliders.length > 0 ? (
        <Swiper
          slidesPerView={1}
          loop
          modules={[Pagination, Navigation]}
          pagination
        >
          {homepageSlider.sliders.map((slider, index) => (
            <SwiperSlide key={index}>
              <div className="static-slider">
                {slider.files && slider.files.length > 0 && (
                  <img
                    className="static-swiper"
                    src={`${API.BASE}${slider.files[0]}`}
                    alt={`Slider Image ${index}`}
                  />
                )}
                {slider.sliderContents && slider.sliderContents.length > 0 && (
                  <img
                    src={`${API.BASE}${
                      lang === "tr"
                        ? slider.sliderContents[0].files[0]
                        : slider.sliderContents[0].filesEN[0]
                    }`}
                    alt={`Slider Content Image ${index}`}
                    className="slogan"
                  />
                )}
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      ) : (
        <p></p>
      )}
    </div>
  );
};

export default Slider;
